export const getErrorMessage = (error: any): string | null => {
  try {
    if (Array.isArray(error) && error.length > 0) {
      return error.map(getErrorMessage).join(' | ');
    }
    if (typeof error === 'object') {
      return error?.message ? error.message : JSON.stringify(error);
    }
    if (typeof error === 'string' && error.length > 0) {
      return error;
    }
    if (typeof error === 'number') {
      return error.toString();
    }
  } catch (_ignore) {
    // Ignore any message that can't be determined
  }
  return null;
};
